document.addEventListener('DOMContentLoaded', function () {
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
  var sel = document.querySelector('[data-variant-select]');
  var price = document.querySelector('[data-price]');
  if (sel && price) {
    sel.addEventListener('change', function () {
      price.textContent = sel.options[sel.selectedIndex].getAttribute('data-price');
    });
  }
});
